module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-9.8d70ea50.mp3";